import React, { useEffect, useState } from 'react'
import { DropzoneArea } from 'mui-file-dropzone'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

type Props = {
  onChangePdf: (arg1) => void
  loadedPdfName?: string
}

const PdfFields = ({ onChangePdf, loadedPdfName = '' }: Props) => {
  const [loadedPdf, setLoadedPdf] = useState<string>('')

  const onDrop = (files) => {
    const reader = new FileReader()

    reader.onload = () => {
      setLoadedPdf('pdf')
      onChangePdf(reader.result)
    }

    reader.readAsDataURL(files[0])
  }

  useEffect(() => {
    setLoadedPdf(loadedPdfName)
  }, [loadedPdfName])

  return (
    <S.Section>
      <S.DropzoneContainer hide={(loadedPdf !== '')}>
        <DropzoneArea
          fileObjects={[]}
          acceptedFiles={['application/pdf']}
          filesLimit={1}
          dropzoneText="Drag and drop a PDF file here or click"
          onDrop={onDrop}
        />
      </S.DropzoneContainer>

      {loadedPdf !== '' && (
        <S.RemovePdf>
          <NavLink
            to="#"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault()
              setLoadedPdf('')
            }}
          >
            Edit PDF
          </NavLink>
        </S.RemovePdf>
      )}
    </S.Section>
  )
}

export default PdfFields

const S = {
  RemovePdf: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 750px;
  `,
  DropzoneContainer: styled.div.withConfig({
    shouldForwardProp: (prop) => !['hide'].includes(prop)
  })<{ hide: boolean }>`
    ${({ hide }) => hide && `
      display: none;
    `}
  `,
  Section: styled.div`
    width: fit-content;
    min-width: 250px;
  `
}
